import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCrawlStructured implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrawlStructuredContainer";
    }
    render(){
        // console.log("Crawl Structured");
    }
}
